import variant from '@styled-system/variant';
import { styles as textVariants } from '../text';
import { Theme } from '../theme';

export const validStyle = {
  boxShadow: (theme: Theme) => `inset 0 0 0 1px ${theme.colors.success[0]}`,
};

export const invalidStyle = {
  boxShadow: (theme: Theme) => `inset 0 0 0 1px ${theme.colors.error[0]}`,
};

export const inputStyle = ({ valid, invalid }) => ({
  ...textVariants['1r'],
  width: '100%',
  position: 'relative',
  lineHeight: 1,
  padding: 4,
  border: 0,
  borderRadius: 1,
  '&::placeholder': {
    color: 'gray.3',
  },
  '&:focus': {
    boxShadow: (theme: Theme) =>
      `inset 0 0 0 1px ${theme.colors.indigo[3]} !important`,
  },
  '&:not(:placeholder-shown)': {
    '&:invalid': !valid && invalidStyle,
    '&:valid': !invalid && validStyle,
  },
  ...(invalid && invalidStyle),
  ...(valid && validStyle),
  '&[disabled]': {
    cursor: 'not-allowed',
    backgroundColor: 'gray.6',
    color: 'gray.4',
  },
});

export const inputVariant = variant({
  variants: {
    onWhite: {
      color: 'gray.1',
      backgroundColor: 'gray.7',
      '&:hover:not(:focus)': {
        boxShadow: 'inset 0 0 0 1px gray.6',
      },
    },
    onGray: {
      color: 'gray.1',
      backgroundColor: 'white',
      '&:hover:not(:focus)': {
        boxShadow: (theme: Theme) => `inset 0 0 0 1px ${theme.colors.gray[6]}`,
      },
    },
    onBlack: {
      color: 'gray.5',
      boxShadow: (theme: Theme) => `inset 0 0 0 1px ${theme.colors.gray[3]}`,
      backgroundColor: 'transparent',
      '&[disabled]': {
        backgroundColor: 'transparent',
        color: 'gray.4',
      },
    },
  },
});

